import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useVoucherProduct = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getAllVoucherProducts = async () => {
    const responseData = await sendRequest({
      url: '/api/v1/voucherProduct',
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });
    return Array.isArray(responseData) ? responseData : [];
  };

  const getVoucherProductById = async voucherProductId => {
    const responseData = await sendRequest({
      url: `/api/v1/voucherProduct/${voucherProductId}`,
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });
    return responseData;
  };

  return {
    isLoading,
    error,
    getAllVoucherProducts,
    getVoucherProductById,
  };
};

export default useVoucherProduct;
